// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 10402-现金收银 现金支付处理 POST /web/v1/pay/cash */
export async function cashPay(
  body: API.SwimPayCashVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimPayCreateRespVo>("/web/v1/pay/cash", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10401-支付下单 创建支付订单 POST /web/v1/pay/create */
export async function createPay(
  body: API.SwimPayCreateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimPayCreateRespVo>("/web/v1/pay/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10409-支付订单列表查询 分页查询支付订单列表，支持按支付日期、状态、支付类别筛选 POST /web/v1/pay/list */
export async function getPayOrderList(
  body: API.SwimPayOrderListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimPayOrderListVo>(
    "/web/v1/pay/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10404-支付回调通知 接收支付平台回调通知 POST /web/v1/pay/notify */
export async function payNotify(
  body: string,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/pay/notify", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10403-支付结果查询 查询支付订单状态 GET /web/v1/pay/query/${param0} */
export async function queryPayResult(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.queryPayResultParams,
  options?: { [key: string]: any }
) {
  const { payOrderId: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimPayQueryRespVo>(
    `/web/v1/pay/query/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10405-退款申请列表 分页查询退款申请列表 POST /web/v1/pay/refund/applyList */
export async function getRefundApplyList(
  body: API.SwimRefundApplyListVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimRefundListVo>(
    "/web/v1/pay/refund/applyList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10406-退款申请审核 审核退款申请 POST /web/v1/pay/refund/audit */
export async function auditRefund(
  body: API.SwimRefundAuditVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/pay/refund/audit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10408-退款回调通知 接收退款平台回调通知 POST /web/v1/pay/refund/notify */
export async function refundNotify(
  body: string,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/pay/refund/notify", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10407-退款结果查询 查询退款结果 GET /web/v1/pay/refund/query/${param0} */
export async function queryRefundResult(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.queryRefundResultParams,
  options?: { [key: string]: any }
) {
  const { refundId: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimRefundQueryRespVo>(
    `/web/v1/pay/refund/query/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
